export const formatPricingTier = (tier: { paymentInterval?: number; term?: number } | undefined) => {
  if (tier == null) {
    return;
  }
  if (tier.paymentInterval == null || tier.term == null) {
    return;
  }
  return `${tier.paymentInterval}:${tier.term}`;
};
